export const common = {
  // Navigation
  "nav.home": "الرئيسية",
  "nav.about": "عنا",
  "nav.services": "الخدمات",
  "nav.products": "المنتجات", 
  "nav.certifications": "الشهادات",
  "nav.partnerships": "الشراكات",
  "nav.contact": "اتصل بنا",
  "nav.quote": "احصل على عرض أسعار",
  
  // Common buttons
  "button.learnMore": "تعرف أكثر",
  "button.getQuote": "احصل على عرض أسعار",
  "button.contactUs": "اتصل بنا", 
  "button.viewAll": "عرض الكل",
  "button.download": "تحميل",
  
  // Common text
  "company.name": "مجموعة دريكسيم",
  "company.tagline": "متخصصون ماليزيون في زيت النخيل",
  "language.current": "العربية"
};

export default common;